import { useFeedStore } from "@/common/store/useFeedStore";
import { useScrollStore } from "@/common/store/scrollStore";

export const SNAP_ROOT_SELECTOR = "#root";
export const SNAP_FEED_CLASS_NAME = "withSnapFeed";

const SNAP_FEED_ENTERING_CLASS = "snapFeedEntering";
const SNAP_SHOW_HEADER_THRESHOLD = 30;
const SNAP_TRANSITION_DURATION = 500;

type TransitionCleanup = () => void;

export const enableSnapFeedState = (
  rootElement?: HTMLElement | null,
  onTransitionEnd?: TransitionCleanup,
): NodeJS.Timeout | null => {
  if (!rootElement) {
    return null;
  }

  rootElement.classList.add(SNAP_FEED_CLASS_NAME);

  const { setV2Header } = useFeedStore.getState();
  setV2Header(true);

  rootElement.classList.add(SNAP_FEED_ENTERING_CLASS);

  const transitionTimeout = setTimeout(() => {
    rootElement.classList.remove(SNAP_FEED_ENTERING_CLASS);
    onTransitionEnd?.();
  }, SNAP_TRANSITION_DURATION);

  return transitionTimeout;
};

export const resetSnapFeedState = (rootElement?: HTMLElement | null) => {
  if (!rootElement) {
    return;
  }

  rootElement.classList.remove(SNAP_FEED_CLASS_NAME);

  const { setV2Header } = useFeedStore.getState();
  setV2Header(false);

  const { scrollElement } = useScrollStore.getState();

  setTimeout(() => {
    scrollElement?.classList.remove("scrolled");
  }, SNAP_SHOW_HEADER_THRESHOLD);
};
